<template>
  <v-dialog max-width="500px" v-model="dialog" @keydown.enter.prevent="onenter">
    <v-card>
      <v-card-title>
        <span class="headline">World Region ({{ this.rules.name }})</span>
        <v-spacer/>
        <r-authorize
            :master="masterAccess"
            :locked.sync="model.locked"
            :enabled.sync="model.enabled"
        />
      </v-card-title>
      <v-card-text>
        <v-col cols="4" sm="2" md="2">
          <v-btn @click="showPreview()" class="mr-2" small>View JSON</v-btn>
        </v-col>
        <v-row dense>
          <v-col cols="12" md="4" sm="4">
            <v-text-field label="Region:" v-model.number="model.region" hide-details/>
          </v-col>
          <v-col cols="12" md="4" sm="4">
            <v-text-field label="Game Level:" v-model.number="model.gameLevel" hide-details/>
          </v-col>
          <v-col cols="12" md="4" sm="4">
            <v-text-field label="Level lock:" v-model.number="model.userLevel" hide-details/>
          </v-col>
        </v-row>
        <v-row dense>
          <v-col cols="12" md="8" sm="8">
            <r-item-dropdown label="Blocker:" :model.sync="model.blocker"/>
          </v-col>
          <v-col cols="12" sm="4" md="4" align="center">
            <v-btn v-if="!!model.search" @click="search" small color="success"
                   class="my-4 fill-width">Search
            </v-btn>
            <v-btn v-else @click="search" small outlined color="primary" class="my-4 fill-width">Search</v-btn>
          </v-col>
          <v-col cols="12"/>
        </v-row>
        <v-expansion-panels>
          <r-tile-panel :items.sync="model.tiles" title="Cells"/>
          <r-currency-panel :items.sync="model.money" title="Currency"/>
          <r-reward-panel :model.sync="model.reward" title="Reward"/>
          <r-trigger-panel :items.sync="model.triggers" title="Triggers"/>
          <r-wonders-panel :items.sync="model.wonders" title="Wonders"/>
        </v-expansion-panels>
      </v-card-text>
      <v-card-actions>
        <v-spacer/>
        <v-btn @click="cancel" color="blue darken-1" text>
          Cancel
        </v-btn>
        <v-btn @click="save" color="blue darken-1" text v-if="!lockedAssess || masterAccess">
          Save
        </v-btn>
      </v-card-actions>
    </v-card>
    <r-search-dialog ref="r-search-dialog"/>
    <r-preview-dialog ref="preview-dialog"></r-preview-dialog>
  </v-dialog>
</template>

<script>
import {ViewRules} from "@/common/ViewRules";
import {WorldRegion} from "@/modules/redactor/models/world-region/WorldRegion";
import {RedactorUtils} from "@/modules/redactor/core/RedactorUtils";

import RSearchDialog from "@/modules/redactor/views/search/r-search-dialog";
import RAuthorize from "@/modules/redactor/views/common/r-authorize";
import RItemDropdown from "@/modules/redactor/views/item/r-item-dropdown";
import RCurrencyPanel from "@/modules/redactor/views/currency/r-currency-panel.vue";
import RTilePanel from "@/modules/redactor/views/utils/r-tile-panel.vue";
import RTriggerPanel from "@/modules/redactor/views/trigger/r-trigger-panel.vue";
import RWondersPanel from "@/modules/redactor/views/wonders/r-wonders-panel.vue";
import RPreviewDialog from "@/modules/redactor/views/preview/r-preview-dialog.vue";
import RRewardPanel from "@/modules/redactor/views/reward/r-reward-panel.vue";


export default {
  name: "r-world-region-dialog",
  components: {RPreviewDialog, RWondersPanel, RTriggerPanel, RTilePanel, RCurrencyPanel, RItemDropdown, RAuthorize, RSearchDialog, RRewardPanel},
  data: () => ({
    dialog: false,
    resolve: null,
    reject: null,
    model: new WorldRegion(),
    rules: ViewRules.READONLY,
  }),
  computed: {
    lockedAssess() {
      return this.model.locked;
    },
    masterAccess() {
      return RedactorUtils.hasMasterAccess();
    }
  },
  methods: {
    show(rules, model) {
      this.dialog = true;
      this.rules = rules;
      this.model = model || new WorldRegion();

      if (ViewRules.COPY.equal(this.rules)) {
        this.model.locked = false;
      }

      return new Promise((resolve, reject) => {
        this.resolve = resolve;
        this.reject = reject;
      });
    },
    save() {
      if (this.model.valid()) {
        this.resolve(this.model);
        this.discard();
      } else {
        this.$alert("Invalid config!");
      }
    },
    cancel() {
      this.reject();
      this.discard();
    },
    discard() {
      this.dialog = false;
    },
    onenter() {
      if (!this.lockedAssess || this.masterAccess) {
        this.save();
      } else {
        this.cancel();
      }
    },
    search() {
      let data = this.model.search ? this.model.search.clone() : null;
      this.$refs['r-search-dialog'].show(ViewRules.UPDATE, data).then(data => {
        this.model.search = data;
      }).catch(() => {
      });
    },
    showPreview() {
      this.$refs['preview-dialog'].show(this.rules, this.model, WorldRegion)
        .then((result) => {
          Object.assign(this.model, result);
        })
        .catch((e) => {
          this.$alert("Failed to parse config!" + e.message);
        });
    }
  }
}
</script>